import { Eyebrow } from '@league/ui';

/**
 * A route that exists in the sitemap and is not built yet.
 *
 * It says so, plainly, and names the phase. The alternative — a screen of plausible-looking
 * invented content — is the thing the design bundle warns about in its own instructions: anything
 * in `[ SQUARE BRACKETS ]` is rendered as a bracket, not invented. A fake metric on a director's
 * dashboard gets believed, and a fake one on the commissioner's gets acted on.
 *
 * The routes exist rather than 404ing because the shells are what is being built: a rail whose
 * items lead nowhere cannot be walked, and walking it is how you find out the grouping is wrong.
 */
export function Placeholder({
  title,
  phase,
  what,
}: {
  title: string;
  /** Which build phase this lands in, from docs/UI-UX-SPEC.md §10. */
  phase: string;
  /** One sentence on what will be here, so the rail can be judged before the pages exist. */
  what: string;
}) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4 px-6 py-10">
      <div>
        <Eyebrow>{phase}</Eyebrow>
        <h1 className="mt-1 font-display text-2xl leading-tight">{title}</h1>
      </div>

      <div className="rounded-card border border-dashed border-stroke bg-paper px-6 py-8">
        <p className="text-[15px]">{what}</p>
        <p className="mt-2 text-[13px] text-ink-2">
          Not built yet. This page exists so the navigation can be walked and judged before the
          screens behind it are made.
        </p>
      </div>
    </div>
  );
}
